import { SeoRenderer } from "../../../common/helpers/seo";
import { IStateTree } from "../../store/interfaces";

import loadingComponent from "./loadable";

export default {
    component: loadingComponent,
    renderSeo: (store: () => IStateTree, allMessage: {[key: string]: string}, lang: string) => {
        SeoRenderer({ title: allMessage["homework.completed.title"], allMessage, lang });
    },
};
